import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
import ArrowBackIosTwoToneIcon from "@mui/icons-material/ArrowBackIosTwoTone";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddFields,
  setExtraFieldsData,
  setGuestDetailsData,
  setGuestFields,
  setQuantities,
  setSelectedExtraProduct,
  setTransactionDetails,
  toggleBookNowOpen,
} from "../../store/slice/Activity.slice";
import {
  CircularProgress,
  Paper,
  StepConnector,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ConfirmandPay from "./ConfirmAndPay";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getExtraFieldDetails,
  getGuestDetails,
  transactionCostForReservation,
} from "../../api/HorecaWidget.service";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Snackbar from "@mui/material/Snackbar";
import dayjs from "dayjs";
import {
  format_Number,
} from "../../utils/utils";
import { CreateActivity } from "../../api/activity.service";
import Combination from "../Component/Combination";
import UpsaleProduct from "../Component/UpsaleProduct";
import UserDetailsSection from "../Component/UserDetailSection";
//import Combination from "./Combinations";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing

const DottedStepConnector = (props) => (
  <StepConnector
    {...props}
    sx={{
      "& .MuiStepConnector-line": {
        borderColor: "#000000", // Line color
        borderStyle: "dashed", // Dashed line style (simulates dotted with spacing)
        borderWidth: 1, // Line thickness
      },
    }}
  />
);

export default function BookNowActivities() {
  const { defaultLang } = useSelector((store) => store?.Combination);
  const theme = useTheme();
  const {
    key,
    widgetConfig,
    guestId,
  } = useSelector((store) => store?.widgetSettings);

  const {
    reservType,
    combinationQTY,
    GuestDetailsData,
    extraProductData,
    extraFieldsData,
    adult,
    child,
    kid,
    baby,
    toddler,
    selectedDate,
    time,
    totalCount,
    selectedExtraProduct,
    transactionDetails,
    guestFields,
    addFields,
    defaultLanguage,
    languageWords,
    activityDuration,
    combinationList,
    selectedCombination,
    AvailableLocationData,
    TotalVAT,
    quantities,
  } = useSelector((store) => store.Activity);
  const [isLoading, setIsLoading] = React.useState(false);
  const [steps, setSteps] = React.useState([
    languageWords?.Availability,
    languageWords?.ExtraProducts,
    languageWords?.combinations,
    languageWords?.yourDetails,
    languageWords?.ConfirmandPay,
  ]);

  //calculation
  const PRODUCT_PRICE =
    (activityDuration?.price || reservType?.products[0]?.price) *
    (!activityDuration?.price ? totalCount : AvailableLocationData?.length);

  const VAT_PERCENT_PRODUCTS =
    activityDuration?.vat || reservType?.products[0]?.vat;
  const VAT_TOTAL_PRODUCTS =
    PRODUCT_PRICE - PRODUCT_PRICE / (1 + VAT_PERCENT_PRODUCTS / 100);

  const VAT_TOTAL_EXTRA = selectedExtraProduct?.reduce((acc, product) => {
    return acc + (product?.price - product?.price / (1 + product?.vat / 100));
  }, 0);
  const VAT_TOTAL_TRANSACTION_COST =
    (transactionDetails?.data?.pricePerReservation -
      transactionDetails?.data?.pricePerReservation /
        (1 + transactionDetails?.data?.vat / 100)) *
    1;

  const TOTAL_VAT = (
    VAT_TOTAL_PRODUCTS +
    VAT_TOTAL_EXTRA +
    VAT_TOTAL_TRANSACTION_COST
  ).toFixed(2);

  const totalSum = selectedExtraProduct?.reduce((acc, product) => {
    return acc + product.quantity * product.price;
  }, 0);
  const totalCombination = selectedCombination?.reduce(
    (acc, product) => acc + product?.price,
    0
  );

  const TOTAL_INCLUSIVE_VAT =
    PRODUCT_PRICE +
    totalSum +
    transactionDetails?.data?.pricePerReservation +
    totalCombination;
  const excludingVAT =
    TOTAL_INCLUSIVE_VAT -
    TOTAL_VAT -
    transactionDetails?.data?.pricePerReservation;
  

  const [loading, setLoading] = React.useState(false);
  // console.log(GuestDetailsData,"extraProductData")
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(1);
  const [completed, setCompleted] = React.useState({ 0: false });

  const { isBookNowOpen } = useSelector((store) => store.addGuest);
  const dispatch = useDispatch();
  const totalSteps = () => steps.length;
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClosebar = () => {
    setState({ ...state, open: false });
  };

  const completedSteps = () => Object.keys(completed).length;

  const isLastStep = () => activeStep === totalSteps() - 1;

  const allStepsCompleted = () => completedSteps() === totalSteps();

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    if (activeStep == 1) {
      navigate(-1);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    setCompleted({
      ...completed,
      [activeStep]: true,
    });
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  // Modal open/close functions
  const handleClickOpen = () => {
    dispatch(toggleBookNowOpen());
  };

  const handleClose = () => {
    dispatch(toggleBookNowOpen());
  };

  const fetchGuestDetails = async () => {
    try {
      const response = await getGuestDetails(
        key,
        reservType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      dispatch(setGuestDetailsData(response));
    } catch (error) {
      console.error(error);
    }
  };

  const creatBookingReservation = async () => {
    setIsLoading(true);
    const parsedDate = dayjs(selectedDate, "DD-MM-YYYY", true);
    // Check if date is valid
    if (!parsedDate?.isValid()) {
      console.error("Invalid date:", selectedDate);
      return;
    }
    // Format the valid date into 'YYYY-MM-DD'
    const formattedDate = parsedDate.format("YYYY-MM-DD");

    const upsaleproduct = selectedExtraProduct?.map((item) => {
      return {
        idupsaleproduct: item?.idproduct,
        quantity: item?.quantity,
        price: item.price * item?.quantity,
        supportingproducts: null,
      };
    });
    const guestPayload=guestFields.reduce((acc, item) => {
      const key = item.idfield.replace(/{|}/g, ""); // Remove curly braces
      acc[key] = item.data;
      return acc;
  }, {});
  const combinationInfoPayload = selectedCombination?.map((item) => {
    let count =combinationQTY[item?.idreservationtype + String(item.isBefore)]
    return {
      idreservationtype: item?.idreservationtype,
      ArrivalDate: formattedDate,
      DepartureDate: formattedDate,
      ArrivalTime: item?.arrivalTime,
      DepartureTime: item?.depatureTime,
      ReservationLocations:item?.tables?.slice(0,count )?.map((table) => ({
        idtables: table?.idtables,
        ArrivalDate: formattedDate,
        DepartureDate: formattedDate,
        ArrivalTime: item?.arrivalTime,
        DepartureTime: item?.depatureTime,
      })),
 
        MainModuleId: item?.mainModuleId,
      Guests: [guestPayload],
      numberOfGuest: totalCount,
      LanguageCode: defaultLanguage,
     
    };
  });
    const payload = {
      ...(guestId ? { guestId } : {}),
      idreservationtype: parseInt(reservType?.idreservationtype),
      kioskMode:widgetConfig?.settings?.kioskMode,
      field1: parseInt(adult),
      field2: parseInt(child),
      field3: parseInt(baby),
      field4: parseInt(toddler),
      field5: parseInt(kid),
      arrivaldate:  dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
      // arrivaltime: `${time};${reservType?.duration};${reservType.durationgroups}`,
      DurationTimeValue: activityDuration ? activityDuration?.timeValue : "",
      SelectedLocation: AvailableLocationData,
      arrivaltime: time,
      key: key,
      language: defaultLang ? defaultLang : defaultLanguage,
      //reservationRequest: false,
      guestFields: guestFields || [],
      fields: addFields,
      app: false,
      // horecaProductReservation: {
      //   idhorecaproduct: parseInt(reservType?.idreservationtype) ?? 0,
      //   numberofguests: parseInt(totalCount),
      //   price:Object.keys(activityDuration)?.length > 0 ? activityDuration?.price :  (reservType?.products[0]?.price *
      //   totalCount)
      // },
      TotalInclusiveAmount: TOTAL_INCLUSIVE_VAT,
      totalVAT: parseFloat(TotalVAT),
      PricePerPerson: {
        idPricePerPerson: parseInt(reservType?.idproducthoreca) ?? null,
        numberofguests: parseInt(totalCount),
        price:
          Object.keys(activityDuration)?.length > 0
            ? 0
            : reservType?.products[0]?.price * totalCount,
      },
      PricePerTime: {
        idPricePerTime: parseInt(reservType?.idproductBowling),
        numberofguests: parseInt(totalCount),
        price:
          Object.keys(activityDuration)?.length > 0
            ? activityDuration?.price * AvailableLocationData?.length
            : 0,
      },
      upsaleProductReservations: upsaleproduct,
      transactionCostReservation: {
        idproduct: parseInt(transactionDetails?.data?.idproduct),
        // parseInt(transactionDetails?.data?.idproduct),
        // idreservation: parseInt(reservType?.idreservationtype),
        price: parseFloat(transactionDetails?.data?.pricePerReservation),
      },
      // baseUrl: "",
      // isGroupReservation: false,
      // reservationRequestMin: reservationRequestMin?.data,
      // MainModuleId: 1,
      CombinationInfo:combinationInfoPayload
    };
    try {
      const result = await CreateActivity(payload);
      if (result?._links?.checkout?.href) {
        window.parent.postMessage(
          {
            redirectUrl: result?._links?.checkout?.href,
          },
          "*"
        );
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const fetchTransactionDetails = async () => {
    try {
      const response = await transactionCostForReservation(
        key,
        reservType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      dispatch(setTransactionDetails(response));
    } catch (error) {
      console.log("error in transaction cost:", error?.message);
      throw new Error(error?.message);
    }
  };
  const createInitialValuesAndValidationSchema = (
    guestData,
    extraData,
    widgetConfig
  ) => {
    const initialValues = {};
    const validationShape = {};

    const processFieldData = (
      field,
      languageType,
      customLink,
      shouldApplyValidation
    ) => {
      let languageData = field[languageType]?.find(
        (f) => f?.fieldname == "name" && f?.data
      )?.data;

      if (customLink) {
        languageData = "Link";
      } else if (field?.type == "textarea") {
        if (typeof field[languageType]?.[0]?.data === "string") {
          languageData = field[languageType]
            ?.find((f) => f?.fieldname == "name")
            ?.data?.replace(".", "");
        } else {
          languageData = field[languageType]?.find(
            (f) => f?.fieldname == "name"
          )?.data;
        }
      }

      if (!languageData) return; // Skip if no valid name is found

      if (field?.type == "checkboxList") {
        initialValues[languageData] = [];
      } else {
        initialValues[languageData] = "";
      }

      let validationRule;

      // Skip validation for 'label' and 'link' types
      if (field?.type === "label" || field?.type === "link") {
        validationRule = Yup.mixed().notRequired(); // No validation for these fields
      } else if (field.tag === "{email}") {
        validationRule = Yup.string().email("Invalid email format");
      } else if (field.tag === "{phone}") {
        validationRule = Yup.string().matches(
          /^\+?\d{1,3}\s*\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
          "Invalid phone number format"
        );
      } else if (field?.type === "termsandcondition") {
        validationRule = Yup.boolean().oneOf(
          [true],
          "You must accept the terms and conditions"
        );
      } else if (field?.type == "checkboxList") {
        validationRule = Yup.array().of(Yup.string());
      } else {
        validationRule = Yup.string();
      }

      // Apply `.required("Required")` **only for guestData** when `!widgetConfig?.token && field.required`
      if (
        shouldApplyValidation &&
        field.required &&
        field?.type !== "label" &&
        field?.type !== "link"
      ) {
        validationRule = validationRule.required("Required");
      }
      validationShape[languageData] = validationRule;
    };

    guestData?.forEach((field) =>
      processFieldData(
        field,
        "guestLanguages",
        field.type == "link",
        !widgetConfig?.token
      )
    );

    extraData?.forEach(
      (field) =>
        processFieldData(field, "fieldsLanguages", field.type == "link", true) // ExtraData should never enforce required validation
    );

    return {
      initialValues,
      validationSchema: Yup.object().shape(validationShape),
    };
  };
  const { initialValues, validationSchema } =
    createInitialValuesAndValidationSchema(
      GuestDetailsData?.data,
      extraFieldsData,
      widgetConfig
    );

  const fetchExtraFieldDetails = async () => {
    try {
      const response = await getExtraFieldDetails(
        reservType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage,
        key
      );
      dispatch(setExtraFieldsData(response));
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    if (extraProductData?.data?.length == 0 && combinationList.length == 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (
      extraProductData?.data?.length == 0 &&
      combinationList.length > 0
    ) {
      setSteps([
        languageWords?.Availability,
        languageWords?.combinations,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [extraProductData]);

  React.useEffect(() => {
    document.body.setAttribute(
      "style",
      "background-color: " + theme?.widget?.stepScreenBgColor + " !important"
    ); // theme?.widget?.stepScreenBgColor;
    if (combinationList.length == 0 && extraProductData?.data?.length == 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (
      combinationList.length == 0 &&
      extraProductData?.data?.length != 0
    ) {
      setSteps([
        languageWords?.Availability,
        languageWords?.ExtraProducts,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [combinationList]);

  React.useEffect(() => {
    if (totalCount >= widgetConfig?.reservationRequestMin) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [totalCount]);

  React.useEffect(() => {
    fetchGuestDetails();
    fetchTransactionDetails();
    fetchExtraFieldDetails();
    //   fetchCombinations()
  }, []);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          //console.log(values);
          // Handle form submission
        }}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          touched,
          errors,
          setFieldTouched,
          setFieldValue,
        }) => (
          <Box
            sx={{
              backgroundColor: theme?.widget?.stepScreenBgColor,
              height: "100vh",
              p: 2,
            }}
          >
            <Box
              sx={{
                backgroundColor: theme?.widget?.stepScreenBgColor,
              }}
            >
              <Box
                sx={{
                  width: "100%", // Take full width
                  overflow: "hidden", // Prevent overflow
                  px: 2,
                  mb: 5,
                }}
              >
                <Stepper
                  nonLinear
                  activeStep={activeStep}
                  connector={<DottedStepConnector />}
                  sx={{
                    flexWrap: { xs: "wrap", sm: "nowrap" }, // Wrap steps on small screens
                    justifyContent: { xs: "center", sm: "flex-start" }, // Center on xs and align to start on sm+
                  }}
                >
                  {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                      <StepButton
                        color="inherit"
                        sx={{
                          ...(activeStep === index && {
                            "& .MuiStepLabel-label": {
                              color:
                                activeStep === index
                                  ? theme?.widget?.stepTextColorActive
                                  : theme?.widget?.stepTextColor,
                              fontWeight: "bold",
                              fontSize: "15px",
                            },
                            "& .MuiStepIcon-root": {
                              color:
                                activeStep === index
                                  ? theme?.widget?.stepCircleBgColor
                                  : theme?.widget?.stepCircleActiveBg,
                              borderRadius: "50%",
                              // Adding the following line for custom icon text color when active
                              "& .MuiStepIcon-text": {
                                fill:
                                  activeStep === index
                                    ? theme?.widget?.stepCircleTextActive
                                    : theme?.widget?.stepCircleTextColor,
                              },
                            },
                          }),
                          width: { xs: "100%", sm: "auto" },
                          fontSize: { xs: "12px", sm: "inherit" },
                        }}
                        onClick={handleStep(index)}
                      >
                        {isSmallScreen ? "" : label}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </Box>
              <div>
                {allStepsCompleted() ? (
                  <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                      All steps completed - you're finished
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Box>
                      {(() => {
                        switch (steps[activeStep]) {
                          case languageWords?.Availability:
                            navigate(-1, {
                              state: { openWidgetScreen: true },
                            });
                            break;

                          case languageWords?.ExtraProducts:
                            return (
                              <UpsaleProduct
                                selectedExtraProduct={selectedExtraProduct}
                                extraProductData={extraProductData?.data}
                                quantities={quantities}
                                selectedCombination={selectedCombination}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={reservType}
                                selectedDate={selectedDate}
                                adult={adult}
                                child={child}
                                kid={kid}
                                baby={baby}
                                toddler={toddler}
                                time={time}
                                transactionDetails={transactionDetails?.data}
                                transactionPrice={
                                  transactionDetails?.data?.pricePerReservation
                                }
                                excludingVat={excludingVAT}
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={PRODUCT_PRICE + totalSum}
                                setQuantities={setQuantities}
                                setSelectedExtraProduct={setSelectedExtraProduct}
                              />
                            );

                          case languageWords?.combinations:
                            return (
                              <Combination
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={reservType}
                                selectedDate={selectedDate}
                                time={time}
                                adult={adult}
                                child={child}
                                kid={kid}
                                baby={baby}
                                toddler={toddler}
                                selectedExtraProduct={selectedExtraProduct}
                                transactionDetails={transactionDetails?.data}
                                transactionPrice={
                                  transactionDetails?.data?.pricePerReservation
                                }
                                excludingVat={excludingVAT}
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={PRODUCT_PRICE + totalSum}
                              />
                            );

                          case languageWords?.yourDetails:
                            return (
                              <UserDetailsSection
                              defaultLanguage={defaultLanguage}
                              values={values}
                              setField={setFieldValue}
                              errors={errors}
                              touched={touched}
                              totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={reservType}
                                selectedDate={selectedDate}
                                time={time}
                                adult={adult}
                                child={child}
                                kid={kid}
                                baby={baby}
                                toddler={toddler}
                                selectedExtraProduct={selectedExtraProduct}
                                transactionDetails={transactionDetails?.data}
                                transactionPrice={
                                  transactionDetails?.data?.pricePerReservation
                                }
                                excludingVat={excludingVAT}
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={PRODUCT_PRICE + totalSum}
                              GuestDetailsData={GuestDetailsData?.data}
                              extraFieldsData={extraFieldsData?.data}
                              setAddFields={setAddFields}
                              setGuestFields={setGuestFields}
                            />
                            );

                          case languageWords?.ConfirmandPay || "Confirm":
                            return <ConfirmandPay />;

                          default:
                            return <div>No page found</div>;
                        }
                      })()}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        mt: 1,
                        pb: 10,
                      }}
                    >
                      <IconButton
                        onClick={handleBack}
                        sx={{
                          mr: 1,
                          borderRadius: "5px",
                          pr: 4,
                          backgroundColor: theme?.details?.backButtonBgColor,
                          color: theme?.details?.backButtonTextColor,
                          "&:hover": {
                            backgroundColor:
                              theme?.details?.backButtonBgColorHover,
                            color: theme?.details?.backButtonTextColorHover,
                          },
                        }}
                      >
                        <ArrowBackIosTwoToneIcon />
                      </IconButton>
                      <Box sx={{ flex: "1 1 auto" }} />
                      {activeStep !== 4 && (
                        <Button
                          startIcon={
                            steps[activeStep] === languageWords?.yourDetails ? (
                              <CreditScoreIcon />
                            ) : (
                              <ArrowForwardIosTwoToneIcon />
                            )
                          }
                          onClick={() => {
                            if (
                              steps[activeStep] === languageWords?.yourDetails
                            ) {
                              if (Object.keys(errors).length == 0) {
                                creatBookingReservation();
                              }

                              // Submit the form when on step 3
                            } else {
                              handleNext(); // Proceed to the next step otherwise
                            }
                          }}
                          type={
                            steps[activeStep] === languageWords?.yourDetails
                              ? "submit"
                              : "button"
                          }
                          sx={{
                            backgroundColor:
                              steps[activeStep] === languageWords?.yourDetails
                                ? reservType?.totalCost > 0
                                  ? theme?.details?.confirmBgColor
                                  : theme?.details?.nextButtonBgColor
                                : theme?.details?.nextButtonBgColor,
                            // color:theme?.details?.nextButtonTextColor,
                            color:
                              steps[activeStep] === languageWords?.yourDetails
                                ? reservType?.totalCost > 0
                                  ? theme?.details?.confirmTextColor
                                  : theme?.details?.nextButtonTextColor
                                : theme?.details?.nextButtonTextColor,
                            "&:hover": {
                              backgroundColor:
                                theme?.details?.nextButtonBgColorHover,
                              color: theme?.details?.nextButtonTextColorHover,
                            },
                          }}
                          disabled={
                            Object.keys(errors).length != 0 &&
                            steps[activeStep] === languageWords?.yourDetails
                          }
                        >
                          {isLoading ? (
                            <CircularProgress size={20} />
                          ) : steps[activeStep] ===
                              languageWords?.yourDetails &&
                            !isNaN(TOTAL_INCLUSIVE_VAT) ? (
                            `€ ${format_Number(
                              parseFloat(TOTAL_INCLUSIVE_VAT).toFixed(2)
                            )}`
                          ) : (
                            ""
                          )}
                        </Button>
                      )}
                    </Box>
                  </React.Fragment>
                )}
              </div>
            </Box>
          </Box>
        )}
      </Formik>
      <Box sx={{ width: 500 }}>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClosebar}
          message="Reservation details saved successfully !"
          key={vertical + horizontal}
        />
      </Box>
    </>
  );
}
